import React from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import useAuth from '../../../hooks/useAuth';
import { useUserLogoutMutation } from '../../../redux/slices/authSlice';

// Components
import Notifications from './Notifications';

import styles from './Header.module.postcss';

function HeaderNavControls() {
  const { auth, dashboardLink } = useAuth();

  const [userLogout] = useUserLogoutMutation();

  return (
    <>
      { !auth.loggedIn &&
        <>
          <Link to='/login' className={cn(styles.Header_Login, 'Button Button--outlined Button--small')}>
            Log In
          </Link>
          <Link to='/catering/register' className={cn(styles.Header_noMobile, styles.Header_PillCta, 'Button Button--small')}>
            Book Catering
          </Link>
        </>
      }

      { auth.loggedIn && auth.admin &&
        <Link to='/admin' className={cn(styles.Header_noMobile, 'Button Button--outlined Button--small')}>
          Admin
        </Link>
      }

      { auth.loggedIn && !auth.admin &&
        <Link to={dashboardLink} className={cn(styles.Header_noMobile, 'Button Button--outlined Button--small')}>
          Dashboard
        </Link>
      }

      { auth.loggedIn &&
        <button
          type='button'
          onClick={userLogout}
          className={cn(styles.Header_noMobile, 'Button Button--outlined Button--small')}
        >
          Log Out
        </button>
      }

      { auth.loggedIn &&
        <Notifications
          admin={auth.admin}
        />
      }
    </>
  );
}

export default HeaderNavControls;
